import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import { useAuthContext } from "./hooks/useAuthContext";

// pages & components
import Dashboard from "./pages/dashboard/Dashboard";
import Login from "./pages/login/Login";
import Signup from "./pages/signup/Signup";
import Navbar from "./components/Navbar";
import { Sidebar } from "./components/Sidebar";
import { Project } from "./pages/project/Project";
import { CreateProject } from "./pages/create/CreateProject";

function App() {
  const { authIsReady, user } = useAuthContext();
  return (
    <div className="App">
      {authIsReady && (
        <BrowserRouter>
         {user &&<Navbar />}
         <div className="flex"> {user && <Sidebar />}
          
          <Switch>
            <Route exact path="/">
              {!user && <Redirect to="/login" />}
              {user && <Dashboard />}
            </Route>
            <Route path="/login">
              {user && <Redirect to="/" />}
              {!user && <Login />}
            </Route>
            <Route path="/projects/:id">
              {!user && <Redirect to="/login" />}
              {user && <Project />}
            </Route>
            <Route path="/create">
              {!user && <Redirect to="/login" />}
              {user && <CreateProject />}

            </Route>
            <Route path="/signup">
              {user && <Redirect to="/" />}
              {!user && <Signup />}
            </Route>
          </Switch></div>
         
          
        </BrowserRouter>
      )}
    </div>
  );
}

export default App;
